module.exports = __webpack_public_path__ + "static/media/58.cf5d79cc.jpg";